const userStatuses = {
  ADDED: 1
};

export default userStatuses;
